export const CASH_FUNDS_ALIASES = ['Cash Funds', 'Cash Funds & Gift Cards'];

export const isValidCashFundAlias = (title: Maybe<string>) => !!title && CASH_FUNDS_ALIASES.includes(title);
